module.exports = __webpack_public_path__ + "static/media/organizations.5b05e7e9.svg";